import React from "react";

import LoadingOrbit from "../components/LoadingOrbit";
import RiskFinancingHeader from "../components/risk_financing/layout/RiskFinancingHeader";
import usePlatformSettings from "../hooks/usePlatformSettings";

import {
    RiskFinancingProvider,
    RiskFinancingContent,
} from "../modules/risk_financing";
import { useAccess } from "../access/AccessContext";
import { PERMISSIONS } from "../access/capabilities";


export default function RiskFinancingPage({
  embedded = false,
  settings: providedSettings,
}) {
  const access = useAccess();
  const canExecuteAnalysis = access.hasPermission(PERMISSIONS.financing.execute);
  const {
    settings: localSettings,
    settingsLoaded: localSettingsLoaded,
    settingsError: localSettingsError,
  } = usePlatformSettings();

  const settings =
    providedSettings ||
    localSettings;

  const settingsLoaded =
    Boolean(providedSettings) ||
    localSettingsLoaded;

  const settingsError =
    providedSettings
      ? null
      : localSettingsError;

  const simulations = Number(
    settings?.simulations ?? 10000
  );

  /*
   * Prevent the Engine from starting before
   * Platform Settings are available.
   */
  if (!settingsLoaded && !settingsError) {
    return (
      <div className={embedded ? "" : "space-y-6 p-6"}>
        {!embedded && <RiskFinancingHeader />}
        <div className={embedded ? "flex min-h-64 items-center justify-center" : ""}>
          <LoadingOrbit />
        </div>
      </div>
    );
  }

  return (
    <RiskFinancingProvider
      settingsLoaded={settingsLoaded}
      simulations={simulations}
      initialTab="portfolio"
      strategyAnalysisEnabled={canExecuteAnalysis}
    >
      <RiskFinancingContent
        embedded={embedded}
        settings={settings}
        settingsLoaded={settingsLoaded}
        settingsError={settingsError}
      />
    </RiskFinancingProvider>
  );
}
